export function getGoToLocation(defaultRoute: string): string {
    const params = new URLSearchParams(window.location.search);
    const goTo = params.get('goTo');
    return goTo || defaultRoute;
}
